module.exports = __webpack_public_path__ + "static/media/logo2.9a862c7b.png";